import { render, staticRenderFns } from "./BaseEntitySync.vue?vue&type=template&id=fbb86664"
import script from "./BaseEntitySync.vue?vue&type=script&lang=js"
export * from "./BaseEntitySync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports